import {WebView, WebViewMessageEvent} from 'react-native-webview';
import EventEmit from '../EventEmit';

export type messageBodyType = any;

export interface responseType {
  eventName: string;
  data: messageBodyType;
  responseEventName?: string;
}

const sign: string = '#suxue#';

function getRandomMessageId(name: string = 'default'): string {
  return name + Math.random();
}

function combineEventAndData(
  eventName: string,
  data: messageBodyType,
  needResponse?: boolean,
): string {
  let content = data;
  if (typeof content !== 'string') {
    try {
      content = JSON.stringify(data);
    } catch (e) {}
  }
  return (
    eventName +
    sign +
    content +
    (needResponse ? `${sign}${getRandomMessageId()}` : '')
  );
}

function splitEventAndData(data: string): responseType {
  const arr = data.split(sign);
  let content = arr[1];
  try {
    content = JSON.parse(content);
  } catch (e) {}
  return {
    eventName: arr[0],
    data: content,
    responseEventName: arr[2],
  };
}

export const injectJavaScriptText = '';

export interface jsRequestConfig {
  eventName: string;
  data: messageBodyType;
  needResponse?: boolean;
  promiseResponse?: boolean;
  timeout?: number;
}

export type ResponseFun = (data: messageBodyType) => void;

export type middlewareType = (
  eventName: string,
  data: messageBodyType,
  res: ResponseFun,
) => void;
export default class WebviewJSBridge {
  // 管理需要响应的事件
  eventBus = new EventEmit();
  timeout: number = 10000;
  WebViewRef: React.MutableRefObject<WebView | null>;
  postMessage?: WebView['postMessage'];
  middlewares: Array<middlewareType> = [];

  constructor(
    middlewares: Array<middlewareType>,
    WebViewRef: React.MutableRefObject<WebView | null>,
  ) {
    this.WebViewRef = WebViewRef;
    this.middlewares.push(...middlewares);
  }

  setPostMessage = (postMessage?: WebView['postMessage']) => {
    this.postMessage = postMessage;
  };

  request(config: jsRequestConfig) {
    const body = combineEventAndData(
      config.eventName,
      config.data,
      config.needResponse,
    );
    return new Promise((resolve, reject) => {
      console.log(this.WebViewRef.current?.postMessage);
      if (this.WebViewRef.current?.postMessage) {
        // @ts-ignore
        this.WebViewRef.current?.postMessage(body, '*');
        if (config.needResponse) {
          const {responseEventName} = splitEventAndData(body);
          this.eventBus.once(
            responseEventName,
            (resData: string, done: () => void) => {
              const {data} = splitEventAndData(resData);
              done();
              resolve(data);
            },
          );
          if (!config.promiseResponse) {
            this.eventBus.once(responseEventName);
            setTimeout(() => {
              reject();
            }, this.timeout);
          }
        } else {
          resolve('noRes');
        }
      } else {
        reject('noPostMessage');
      }
    });
  }

  onMessage = (event: WebViewMessageEvent) => {
    if (typeof event.nativeEvent.data !== 'string') {
      return;
    }
    const {eventName, data, responseEventName} = splitEventAndData(
      event.nativeEvent.data,
    );
    let isRet = false;
    const res: ResponseFun = dataMessage => {
      if (responseEventName) {
        this.request({
          eventName: responseEventName,
          needResponse: false,
          data: dataMessage,
        });
      }
      isRet = true;
    };

    this.eventBus.emit(eventName, data, () => (isRet = true));

    // 处理来自对方的响应事件
    for (let i in this.middlewares) {
      if (!isRet) {
        this.middlewares[i](eventName, data, res);
      }
    }
  };

  addMiddleware(middleware: middlewareType) {
    this.middlewares.push(middleware);
  }
}
